import { useEffect, useRef, useState } from 'react';

export const useScrollReveal = (threshold: number = 0.1) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<any>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => { observer.disconnect(); };
    }, [threshold]);

    return { isVisible, ref };
};
